import React, { Component } from 'react';
import { connect } from 'react-redux';

import { generateInputControls, onChangedHandler, onChangedPlacesAutoCompleteHandler, generateForm } from './../../utils/form/generateFormTools';
import { validate } from './../../utils/form/validation';

//- Actions 
import * as userActions from './../user/userActions'; 

class EditUserForm extends Component {
    
    /**********************
     *     Properties     *
     **********************/

    // defines inputs that belongs to the current form
    // Note : for using several element which have the same Type, they must be named as following
    // syntax : <element's type>_<element's name> 
    elementsForForm = {
        label_username:{
            title: 'Pseudo',
        },
        'label_text-username':{
            title: 'Pseudo'
        },
        password_old: {
            title: 'Ton mot de passe',
            placeholder: 'Ancien mot de passe',
            defaultValue: '' ,
            valid: true, //valid by default
            validation: {
                required: [false, ''],
                minLength: [6, 'Tu es sûr d\'avoir bien tapé ton mot de passe ?'],
                maxLength: [29, 'Tu es sûr d\'avoir bien tapé ton mot de passe ?'],
                isPasswordSecured: [true, 'Tu es sûr d\'avoir bien tapé ton mot de passe ?']
            } 
        },
        password_new: {
            labelPosition: '',
            label: '',
            placeholder: 'Nouveau mot de passe',
            defaultValue: '' ,
            valid: true, //valid by default
            validation: {
                required: [false, ''],
                minLength: [6, 'Un bon mot de passe doit avoir au moins 6 caractères'],
                maxLength: [29, 'Un bon mot de passe doit avoir moins de 30 caractères'],
                isPasswordSecured: [true, 'Ton mot de passe doit avoir au moins une lettre et un chiffre']
            } 
        },
        password_confirm: {
            labelPosition: '',
            label: '',
            placeholder: 'Confirme Mot de passe',
            defaultValue: '',
            valid: true, //valid by default
            validation: {
                required: [false, ''],
            }  
        },
        label_avatar:{
            title: 'Ton personnage'
        },
        avatar:{
            labelPosition: 2
        },
        birthday:{
          //title: 'C\'est quand ta date de naissance ?',
          title: 'Ton anniversaire',
          labelPosition: '',
          label: '',
          placeholder: 'JJ/MM/AAAA',
          defaultValue: '',
          valid: true, //valid by default
        },
        city: {
          title: 'Ta ville',
            defaultValue:'',
            valid: true, //valid by default
        },
        label_parent:{
            title: 'Le mail de tes parents',
        },
        'label_text-parent':{
            title: ''
        },
        submit: {
            defaultValue: 'Je valide' //submit needs value instead of label
        }
    };

    formOrder = {
      block_left: [
        'label_username', 'label_text-username',
        'password_old',
        'password_new',
        'password_confirm'],
      block_middle:[
        'label_avatar','avatar'],
      block_right:[
        'birthday',
        'city', 
        'label_parent','label_text-parent'],
      block_submit: 'submit'
    };
    //-- Set common handler
    inputChangedHandler = onChangedHandler;
    inputChangedPlacesAutoCompleteHandler = onChangedPlacesAutoCompleteHandler;

    /*****************************
     *     Overrided methods     *
     *****************************/

    componentWillReceiveProps(nextProps) {
        let oldUser = this.props.user;

        //-- If page is refresh and information user not set yet
        if( oldUser.username === '' && 
            nextProps.user.username !== '' && 
            nextProps.user.username !== oldUser.username ) {
            //- We need to reload user info display
            this.loadUserInfo(nextProps.user);
        }
    }

    componentWillMount() {
        this.loadUserInfo(this.props.user);
    }

    componentDidMount() {
        //-- Add event listener for carousel
        window.addEventListener('resize', this.resize);
    }

    resize = () => this.forceUpdate()


    componentWillUnmount() {
        //-- Remove event listener for carousel
        window.removeEventListener('resize', this.resize)
    }

    /*****************************
     *     Custom methods     *
     *****************************/
    /**
     * Common method for displaying form information
     * 
     * @param user : is user object information (Store redux)
     */
    loadUserInfo(user) {
        
        //-- Define user information
        this.elementsForForm['label_text-username'].title = user.username;
        this.elementsForForm.avatar.selectedAvatarNumber = user.avatar;
        this.elementsForForm.avatar.value = user.avatar;
        
        this.elementsForForm.birthday.value = 
            new Date(user.birthday)
                .toLocaleString("fr-fr", { 
                    year: "numeric", 
                    month:"2-digit", 
                    day:"2-digit"
                });
        this.elementsForForm.city.defaultValue = user.city;
        this.elementsForForm['label_text-parent'].title = user.emailParent;

        //-- Generate form and push it on state
        this.setState({
            controls: generateInputControls(['label_username','label_text-username',
                                             'password_old',
                                             'password_new',
                                             'password_confirm',
                                             'label_avatar','avatar',
                                             'birthday',
                                             'city', 
                                             'label_parent','label_text-parent',
                                             'submit'], this.elementsForForm),                             
        });
    }
    //-------------------
    //-- HANDLERS

    /**
     * Submit handler validator; He is checking modification before sending
     * 
     * @param event : Dom event called by clicking on submit button
     */
    submitHandler = ( event ) => {
        event.preventDefault();
        
        // check inputs values
        let FormIsValid = true;
        let errors = [];

        const updatedControls = {...this.state.controls};

        const authorizedSafariFormatPattern = /^([0-9]{2})(-|\/)?([0-9]{2})(-|\/)?([0-9]{4})$/;
        const patternFound = this.state.controls.birthday.value.match(authorizedSafariFormatPattern);
        if(patternFound !== null)
        {
            this.state.controls.birthday.value = patternFound[5] + '-' + patternFound[3] + '-' + patternFound[1];
        }
        
        for (let controlName in this.state.controls) {
            const controlElement = this.state.controls[controlName];
            // if form element are invalid and there is no error message set on the field, we update controls accordingly    
            if(controlElement.valid===false){
                
                FormIsValid = false; 
                if(controlElement.errorMessage===''){
                    
                    const validation = validate( controlElement.value, controlElement.validation ); 
                    if(!validation['isValid']){
                        FormIsValid = false;
                        errors.push([controlName, validation['errorMessage']]);
                        updatedControls[controlName] = {
                            ...this.state.controls[controlName],
                            //valid: validation['isValid'],
                            //errorMessage: validation['errorMessage'],
                            touched: true
                        };

                    }
                }
                else {
                    errors.push([controlName, controlElement.errorMessage]);
                }
            }
        }

        //Password validation
        const passwordErrorIndex = errors.findIndex((element) => { return element[0] === 'password_new' });

        //if we have an error on password we delete the error on passwor_confirm
        if( passwordErrorIndex === -1 //no error on password else we keep that error
            && 
            (this.state.controls.password_new.value !== '' || this.state.controls.password_confirm.value !== ''))//at least one password not empty 
        {
            let arr;
            if ( this.state.controls.password_old.value === '' ) 
            {
                FormIsValid = false;
                arr = ['password', 'Hey ! Tu n\'as pas retapé ton ancien mot de passe'];
                errors.splice(0, 0, arr);
            } 
            else if(this.state.controls.password_new.value === '' && this.state.controls.password_confirm.value !== '')
            {
                FormIsValid = false;
                arr = ['password', 'Hey ! Tu as oublié d\'écrire ton mot de passe top secret'];
                errors.splice(0, 0, arr);
            }
            else if(this.state.controls.password_new.value !== '' && this.state.controls.password_confirm.value === '')
            {
                FormIsValid = false;
                arr = ['password', 'Hey ! Tu as oublié de confirmer ton mot de passe'];
                errors.splice(0, 0, arr);
            }
            else if(this.state.controls.password_new.value !== this.state.controls.password_confirm.value)
            {
                FormIsValid = false;
                arr = ['password', 'Tes mots de passe ne sont pas identiques :/'];
                errors.splice(0, 0, arr);
            }
            
        }

        if(FormIsValid){
            this.props.onUpdate( this.state.controls.password_old.value,
                                 this.state.controls.password_new.value,
                                 this.state.controls.avatar.value,
                                 this.state.controls.birthday.value,
                                 this.state.controls.city.value
                                );
        }
        else {
            this.setState( { controls: updatedControls } );
            this.props.onError(errors);
        }
    }

    /*************************
     *    Renders methods    *
     *************************/
    render(){
        //const { hasError, errorMessage } = this.props;
        let form = generateForm(this, this.state.controls, this.formOrder);
       
        return (
            <form onSubmit={this.submitHandler} name="editUserForm">
                {form}
            </form>
        );
    }
} 
 
const mapStateToProps = state => {
    return { 
        hasError: state.user.hasError,
        errorMessage: state.user.errorMessage,
        user: state.user,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getCurrentUser : () => dispatch(userActions.getCurrentUser()),
        onUpdate: (password_old, password, avatar, birthday, city) => dispatch(userActions.updateUserInformation(password_old, password, avatar, birthday, city)),
        onError: (errors) => dispatch(userActions.createUserErrors(errors))
    };
};

export default connect( mapStateToProps, mapDispatchToProps )(EditUserForm);


// WEBPACK FOOTER //
// ./src/components/forms/editUserForm.js